export function getFullUrl(path: string) {
  // Use VITE_SITE_URL if available, otherwise fall back to window.location.origin for SSR compatibility
  const baseUrl =
    import.meta.env.VITE_SITE_URL || (typeof window !== "undefined" ? window.location.origin : "");
  const fullUrl = new URL(path, baseUrl).toString();
  return fullUrl;
}
